import { render, staticRenderFns } from "./FormElementComment.vue?vue&type=template&id=29451f14&scoped=true&"
import script from "./FormElementComment.vue?vue&type=script&lang=js&"
export * from "./FormElementComment.vue?vue&type=script&lang=js&"
import style0 from "./FormElementComment.vue?vue&type=style&index=0&id=29451f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29451f14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
